import {UI} from "../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../stem-core/src/ui/Style";

import {StepDescription} from "../StepDescription";
import {authService} from "../../../../client/connection/Services";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {Messages} from "../../../Messages";
import {PanelChooseCard} from "../../pages/panels/donation/components/PanelChooseCard";
import {MerchantButton} from "../../../common/MerchantButton";
import {PoweredByBlink} from "../../PoweredByBlink";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {DonationStore} from "../../../../client/state/DonationStore";
import {donateMobileState} from "../../inline-donation/DonateMobileState";
import {styleRule} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {paymentMethodController} from "../../inline-donation/PaymentMethodController";


class EditChooseCardPanelStyle extends StyleSheet {
    @styleRule
    title = {
        ...this.themeProps.DONATE_PAGE_CARD_TITLE,
        marginBottom: 6,
    };

    @styleRule
    button = {
        ...this.themeProps.DONATE_PAGE_BUTTON,
        margin: "20px 0 0",
    };

    @styleRule
    back = this.themeProps.DONATE_PAGE_LINK;

    @styleRule
    center = {
        margin: "20px 0",
        textAlign: "center",
    };
}

@registerStyle(EditChooseCardPanelStyle)
export class EditChooseCardPanel extends UI.Element {
    static initialPaymentMethod = null;

    getDonation() {
        return iFrameUserDataService.getActiveRecurringDonation();
    }

    render() {
        const {styleSheet} = this;

        return [
            <StepDescription backFunction={() => this.options.changeURL(authService.isAuthenticated() ?
                DONATE_PAGE_URLS.donate : DONATE_PAGE_URLS.auth, true)}
                             currentStep={StepDescription.stepCount} stepDescription={Messages.paymentStep}/>,
            <div className={styleSheet.title}>{Messages.paymentDetails}</div>,
            <PanelChooseCard hideActiveCard={true} addCardButtonLabel={Messages.addNewCard} ref="chooseCard"
                             selected={paymentMethodController.selectedPaymentMethod}
                             onAddCard={() => this.options.changeURL(DONATE_PAGE_URLS.editAddCard)}
                             onCardSelected={card => {
                                   paymentMethodController.selectedPaymentMethod = card;
                                   this.redraw();
                               }}
                             recurringPayment={this.getDonation()}/>,
            <MerchantButton className={styleSheet.button} disabled={this.chooseCard && !this.chooseCard.getActive()}
                            onClick={() => this.continue()}>
                {Messages.updatePaymentMethod}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.back} className={styleSheet.back}
                      onClick={() => {
                          donateMobileState.updateEditDonationPaymentMethod(this.constructor.initialPaymentMethod);
                          this.redraw();
                          this.options.changeURL(DONATE_PAGE_URLS.editDonation, true)
                      }}/>
            </div>,
            <PoweredByBlink />,
        ];
    }

    continue() {
        donateMobileState.updateEditDonationPaymentMethod(this.chooseCard.getActive());
        this.options.changeURL(DONATE_PAGE_URLS.editDonation, true);
    }

    onMount() {
        super.onMount();
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument() && !this.getDonation()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
